import { useEffect, useState } from "react";

const SHAPES = "path, rect, circle, ellipse, polygon, polyline";
const cache = new Map();

const prepare = (text, className) => {
    const svg = new DOMParser().parseFromString(text, "image/svg+xml").documentElement;
    let index = 0;
    svg.querySelectorAll(SHAPES).forEach((el) => {
        if (el.closest("defs, mask, clipPath")) return;
        el.setAttribute("class", className);
        el.setAttribute("pathLength", "1");
        el.setAttribute("stroke", el.getAttribute("fill") || "currentColor");
        el.style.setProperty("--i", index++);
    });
    svg.removeAttribute("width");
    svg.removeAttribute("height");
    return svg.outerHTML;
};

export const useAnimatedSvg = (src, className) => {
    const key = `${src}|${className}`;
    const [, setLoaded] = useState(0);

    useEffect(() => {
        if (cache.has(key)) return;
        let active = true;
        fetch(src)
            .then((res) => res.text())
            .then((text) => {
                cache.set(key, prepare(text, className));
                if (active) setLoaded((n) => n + 1);
            })
            .catch(() => {});
        return () => {
            active = false;
        };
    }, [key, src, className]);

    return cache.get(key) ?? null;
};

export const markTextShapes = (container, shapeClass, textClass) => {
    const shapes = [...container.querySelectorAll(`.${shapeClass}`)];
    if (!shapes.length) return;
    const boxes = shapes.map((el) => el.getBBox());
    const sorted = [...boxes].sort((a, b) => a.x - b.x);
    let iconEnd = sorted[0].x + sorted[0].width;
    for (const box of sorted.slice(1)) {
        if (box.x > iconEnd) break;
        iconEnd = Math.max(iconEnd, box.x + box.width);
    }
    shapes.forEach((el, i) => {
        if (boxes[i].x < iconEnd) return;
        el.setAttribute("class", textClass);
        el.removeAttribute("stroke");
    });
};
